module.exports = __webpack_public_path__ + "img/drag copy.4a19e202.svg";